import { render } from "./OapDsfAppWrapper.vue?vue&type=template&id=64b9b5a5"
import script from "./OapDsfAppWrapper.vue?vue&type=script&lang=js"
export * from "./OapDsfAppWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__